import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { gqlRequest } from '../../helpers/request';
import { revokeInvitationAction } from '../slices/guestShare';

const queryGQL = `
  mutation hostedWatchRevokeInvitation(
    $invitationId: String,
  ) {
    hostedWatchRevokeInvitation(
      invitationId: $invitationId,
    )
  }
`;

export default (action$) =>
  action$.pipe(
    ofType(revokeInvitationAction.type),
    mergeMap(({ payload }) =>
      gqlRequest({
        query: queryGQL,
        variables: {
          invitationId: `${payload.invitationId}`,
        },
      }).pipe(mergeMap(() => EMPTY)),
    ),
  );
